import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, Card, Space, Typography, Row, Col } from "antd";
import { useTranslate } from "@refinedev/core";

const { Title } = Typography;

export const ServiceProviderEdit = () => {
    const { formProps, saveButtonProps } = useForm();
    const _t = useTranslate();

    return (
        <Edit saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Space direction="vertical" size="large" className="w-full">
                    <Form.Item
                        label={_t("service-providers.fields.name")}
                        name="name"
                        rules={[{ required: true, message: _t("fields.errors.required") }]}
                    >
                        <Input placeholder={_t("service-providers.fields.name")} />
                    </Form.Item>

                    <Card>
                        <Title level={5}>{_t("service-providers.fields.apiAndCredentials")}</Title>
                        <Form.Item
                            label={_t("service-providers.fields.apiEndpoint")}
                            name="apiEndpoint"
                            rules={[
                                { type: "url", message: _t("service-providers.errors.invalidUrl") }
                            ]}
                        >
                            <Input placeholder="https://api.example.com" />
                        </Form.Item>
                        <Row gutter={[16, 0]}>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label={_t("service-providers.fields.clientId")}
                                    name="clientId"
                                >
                                    <Input placeholder={_t("service-providers.fields.clientId")} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                                <Form.Item
                                    label={_t("service-providers.fields.clientSecret")}
                                    name="clientSecret"
                                >
                                    <Input.Password placeholder={_t("service-providers.fields.clientSecret")} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Space>
            </Form>
        </Edit>
    );
};

